import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-vote',
			dom: {
				radio: '.js-vote-radio'
			},
			classes: {
				state: {
					thanks: 'b-vote_state_thanks',
					negative: 'b-vote_state_negative'
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$radio = this.$el.find(this.options.dom.radio);
		return this;
	}

	radioChange(e) {
		const $target = $(e.target);
		const $thisEl = $target.closest(this.options.el);
		const value = $target.val();
		if (value == 1) {
			this.setType($thisEl, this.options.classes.state.thanks);
			this.onSubmit($thisEl);
		}
		if (value == 0) {
			this.setType($thisEl, this.options.classes.state.negative);
			this.onSubmit($thisEl);
		}
	}

	onSubmit(el) {
		const $form = el;
		$.ajax({
			url: $form.attr('action'),
			type: $form.attr('method'),
			data: $form.serialize(),
			dataType: 'json',
			success: function (/* data */) {}
		});
	}

	setType(el, type) {
		const $el = el;
		$el.addClass(type);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$radio.on('change', this.radioChange.bind(this));
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/helper/vote/vote.js